import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useRef, useState } from "react";
import { WkoLoadingSpinner } from "../WkoLoadingSpinner";
import { notifyError } from "../../utils/notifications";
const DISPLAY_TOGGLE_RATIO = 0.1;
function calcPillHeight(maxHeight, value, maxValue) {
    if (maxValue <= 0)
        return 0;
    if (value >= maxValue)
        return maxHeight;
    return Math.sqrt(maxHeight ** 2 * (value / maxValue));
}
export function IndustryStatsPill({ options }) {
    const [loading, setLoading] = useState(true);
    const [industryAvg, setIndustryAvg] = useState(null);
    const [fleetAvg, setFleetAvg] = useState(null);
    const containerRef = useRef(null);
    useEffect(() => {
        if (!options.isReady)
            return;
        setIndustryAvg(null);
        setFleetAvg(null);
        setLoading(true);
        const params = new URLSearchParams({
            fromMonth: options.startDate.substring(0, 7),
            toMonth: options.endDate.substring(0, 7),
            vesselTypes: options.vesselTypes.join(","),
            fleets: options.fleet.map((f) => f.ID).join(","),
        });
        fetch(`/api/benchmark/globalstat?${params}`)
            .then((res) => {
            if (res.ok)
                return res.json();
            throw new Error(res.statusText);
        })
            .then((stats) => {
            setIndustryAvg(Math.round(stats.IndustryAverage * 100) / 100);
            setFleetAvg(Math.round(stats.UserAverage * 100) / 100);
        })
            .catch(() => {
            notifyError("An error has occurred when loading global stats. Please try again.");
        })
            .finally(() => setLoading(false));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [options.isReady, options.startDate, options.endDate, options.vesselTypes.join(","), options.fleet.map((f) => f.ID).join(",")]);
    useEffect(() => {
        const el = containerRef.current;
        if (!el || industryAvg == null || fleetAvg == null)
            return;
        const maxHeight = el.clientHeight;
        if (maxHeight <= 0)
            return;
        const industryH = industryAvg > fleetAvg ? maxHeight : calcPillHeight(maxHeight, industryAvg, fleetAvg);
        const fleetH = fleetAvg > industryAvg ? maxHeight : calcPillHeight(maxHeight, fleetAvg, industryAvg);
        el.style.setProperty("--industry-ratio-height", `${industryH}px`);
        el.style.setProperty("--fleet-ratio-height", `${fleetH}px`);
    }, [industryAvg, fleetAvg]);
    if (loading)
        return _jsx(WkoLoadingSpinner, {});
    return _jsx(IndustryPill, { ref: containerRef, industryAvg: industryAvg, fleetAvg: fleetAvg });
}
function IndustryPill({ industryAvg, fleetAvg, ref }) {
    if (industryAvg == null || fleetAvg == null)
        return null;
    const lowerIndustry = fleetAvg < industryAvg;
    const className = `globalstats-pill ${lowerIndustry ? "lower-industry" : "higher-industry"}`;
    return (_jsxs("div", { ref: ref, title: "Number of NC days per vessel per month", className: className, children: [_jsxs("h3", { className: `pill-value industry-value${(industryAvg / fleetAvg) < DISPLAY_TOGGLE_RATIO ? " small-value" : ""}`, children: ["Industry: ", _jsx("span", { children: industryAvg }), " nc/vessel/month"] }), _jsxs("h3", { className: `pill-value fleet-value${(fleetAvg / industryAvg) < DISPLAY_TOGGLE_RATIO ? " small-value" : ""}`, children: ["Your fleet: ", _jsx("span", { children: fleetAvg }), " nc/vessel/month"] }), _jsxs("div", { className: "pills", children: [_jsx("div", { className: "pill industry-pill shadow", style: { zIndex: fleetAvg > industryAvg ? 6 : "auto" } }), _jsx("div", { className: "pill fleet-pill shadow" })] })] }));
}
